module.exports = __webpack_public_path__ + "img/000.d770a9bd.gif";